/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CustomInputs */

const en_custom = /** @type {(inputs: CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom`)
};

const fr_custom = /** @type {(inputs: CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personnalisé`)
};

const de_custom = /** @type {(inputs: CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brauch`)
};

const it_custom = /** @type {(inputs: CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costume`)
};

const ru_custom = /** @type {(inputs: CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обычай`)
};

const es_custom = /** @type {(inputs: CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Costumbre`)
};

const zh_cn2_custom = /** @type {(inputs: CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`风俗`)
};

const ja_custom = /** @type {(inputs: CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタム`)
};

const hi_custom = /** @type {(inputs: CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिवाज़`)
};

const pt_pt2_custom = /** @type {(inputs: CustomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalizado`)
};

/**
* | output |
* | --- |
* | "Custom" |
*
* @param {CustomInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const custom = /** @type {((inputs?: CustomInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CustomInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_custom(inputs)
	if (locale === "de") return de_custom(inputs)
	if (locale === "it") return it_custom(inputs)
	if (locale === "ru") return ru_custom(inputs)
	if (locale === "es") return es_custom(inputs)
	if (locale === "zh-CN") return zh_cn2_custom(inputs)
	if (locale === "ja") return ja_custom(inputs)
	if (locale === "hi") return hi_custom(inputs)
	if (locale === "pt-PT") return pt_pt2_custom(inputs)
	return en_custom(inputs)
});